import { Grid } from '@mui/material';
import { InputOnlyField, Select, Text } from '@ngt/forms';
import { Condition } from '@ngt/forms-core';
import { FC } from 'react';

const columnMapping = {
    xs: 12,
    sm: 6,
    md: 3
}

const requiresSpecialitySpecification = ({value}: any) => value.speciality == 15;
const requiresHeardAboutAsmSpecification = ({value}: any) => value.heardAboutAsm == 30;

const SpecialityFields: FC = () => {
    return (
        <>
            <Grid 
                item 
                marginTop='16px'
                {...columnMapping}>
                <InputOnlyField
                    label="Speciality"
                    propertyPath="speciality"
                    component={Select}
                    variant="standard"
                />
            </Grid>
            <Grid 
                item 
                {...columnMapping}>
                <Condition
                    condition={requiresSpecialitySpecification}
                >
                    <InputOnlyField
                        label="Other Specification"
                        propertyPath="otherSpecification"
                        component={Text}
                        variant="standard"
                        margin="normal"
                    />
                </Condition>
            </Grid>
        </>
    );
}

export default SpecialityFields;
